import { Component, OnInit } from '@angular/core';
import { FormField } from '../../../dto/util/form-field';
import { FormGroup, Validators } from '@angular/forms';
import { Constants } from '../../../constants/constants';
import { matchPasswordValidator } from '../validaciones/password-match.validator';
import { AutenticacionService } from '../services/autenticacion.service';
import {
  CambiarContraseniaResponseDto,
  RespuestaCambioConstraseniaDTO,
} from '../../../dto/auth/cambiar-contrasenia.response.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { timer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cambiar-contrasenia',
  templateUrl: './cambiar-contrasenia.component.html',
  styleUrl: './cambiar-contrasenia.component.scss',
})
export class CambiarContraseniaComponent implements OnInit {
  cambioContrasenaForm: FormField[] = [];
  token?: string;

  // Multilenguaje
  alertaText: any = {};

  constructor(
    private activatedRoute: ActivatedRoute,
    private autenticacionService: AutenticacionService,
    private alertaModalService: AlertaModalService,
    private router: Router,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.translate.stream('cambiar_contrasena').subscribe(text => {
      this.alertaText = text;
      this.cargarFormulario();
    });
    this.activatedRoute.params.subscribe((params: any) => {
      this.token = params['token'];
    });
    this.cargarFormulario();
  }

  cargarFormulario() {
    this.cambioContrasenaForm = [
      {
        name: 'contrasenaAntigua',
        label: this.alertaText['contrasena_antigua'],
        type: 'password',
        placeholder: this.alertaText['contrasena_antigua_placeholder'],
        required: true,
        width: '12',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required: this.alertaText['contrasena_antigua_required'],
        },
      },
      {
        name: 'nuevaContrasena',
        label: this.alertaText['nueva_contrasena'],
        type: 'password',
        placeholder: this.alertaText['nueva_contrasena_placeholder'],
        required: true,
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(8),
          Validators.pattern(Constants.REGEX_PASSWORD_VALIDATION_WITH_CHARACTERS),
        ],
        errorMessages: {
          required: this.alertaText['nueva_contrasena_required'],
          minLength: this.alertaText['nueva_contrasena_minlength'],
          pattern:  `${this.alertaText['password_info']}
          <ul>
            <li>${this.alertaText['password_mayuscula']}</li>
            <li>${this.alertaText['password_minuscula']}</li>
            <li>${this.alertaText['password_numero']}</li>
            <li>${this.alertaText['password_caracter']}</li>
            <li>${this.alertaText['password_length']}</li>
          </ul>
        `,
        },
      },
      {
        name: 'repetirNuevaContrasena',
        label: this.alertaText['repita_contrasena'],
        placeholder: this.alertaText['repita_contrasena'],
        type: 'password',
        required: true,
        width: '12',
        visible: true,
        validation: [matchPasswordValidator('nuevaContrasena')],
        errorMessages: {
          required: this.alertaText['repita_contrasena_required'],
          matchPassword: this.alertaText['repita_contrasena_matchPassword'],
        },
      },
    ];
  }

  onSubmitCambioContrasenia(form: FormGroup) {
    const request: CambiarContraseniaResponseDto = {
      contrasenaActual: form.get('contrasenaAntigua')?.value,
      contrasenaNueva: form.get('nuevaContrasena')?.value,
      confirmarNuevaContrasena: form.get('repetirNuevaContrasena')?.value,
    };


    if(request.contrasenaActual === request.contrasenaNueva){
        this.alertaModalService.advertencia(
        'La contraseña nueva no puede ser igual a la antigua'
      );
      return;
    }

    // if (this.token == undefined) {
    //   this.alertaModalService.error(
    //     this.alertaText['titulo_error'],
    //     this.alertaText['contenido_error']
    //   );
    // } else {
      this.autenticacionService
        .cambiarConstrasenia(
          this.token,
          request)
        .subscribe({
          next: () => {
            this.alertaModalService.exito(
              this.alertaText['titulo_exito'],
              this.alertaText['contenido_exito']
            );
            timer(3000).subscribe(() => {
              this.redirect();
            });
          },
          error: error => {
            this.alertaModalService.error('Error', `${error?.error?.message}`);
          },
        });
    // }
  }

  redirect() {
    this.router.navigate(['/login']);
  }
}
